import type { Payments } from 'slices/payments';

import { Nullable } from '../../../types/utils';

const getPayments = (state: Nullable<Payments>) => {
  if (!state) return {};

  return {
    paymentType: state.paymentMethod,
    paymentFrequency: state.paymentFrequency === 'M' ? 'monthly' : 'oneOff',
  };
};

export default getPayments;
